import React, { useEffect, useState } from "react";
import { adminGetAllProducts, adminDeleteProduct } from "../api/admin";
import ProductTable from "../components/ProductTable";
import ProductForm from "../components/ProductForm";
import "./ProductsPage.css";
import { toast } from "react-toastify";

const ProductsPage = () => {
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [editingProduct, setEditingProduct] = useState(null);
  const [showForm, setShowForm] = useState(false); // State for modal visibility

  const role = localStorage.getItem("adminRole");
  const permissions = JSON.parse(localStorage.getItem("adminPermissions") || "[]");

  const hasWritePermission = () => {
    if (role === "admin") return true;
    return permissions.includes("Products:write");
  };

  const cancelEdit = () => {
    setEditingProduct(null);
    setShowForm(false);
  };

  const fetchProducts = async () => {
    try {
      const res = await adminGetAllProducts();
      setProducts(res.data || []);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const filteredProducts = (products || []).filter(p => {
    const term = searchTerm.toLowerCase();
    return (
      (p.p_name || "").toLowerCase().includes(term) ||
      (p._id || p.id || "").toLowerCase().includes(term) ||
      (p.p_category || "").toLowerCase().includes(term) ||
      (p.p_Product_Type || "").toLowerCase().includes(term) ||
      (p.category_id?.category_name || p.category?.category_name || "").toLowerCase().includes(term)
    );
  });

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this product?")) return;
    try {
      await adminDeleteProduct(id);
      fetchProducts();
      toast.success("Product deleted successfully! 🗑️");
    } catch (error) {
      console.error("Error deleting product:", error);
      toast.error(error.response?.data?.message || "Failed to delete product. ❌");
    }
  };

  const handleEdit = (product) => {
    setEditingProduct(product);
    setShowForm(true); // Open modal for editing
  };


  return (
    <div className="admin-page">
      {!showForm ? (
        <>
          <div className="page-header">
            <h2 className="adminproducts">Products</h2>
            <div className="header-actions">
              <div className="search-container">
                <span className="search-label">Search:</span>
                <input
                  type="text"
                  className="user-search-input"
                  placeholder="Find by product name, ID, category..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="header-controls-row">
                <div className="admin-count-badge">
                  Total Products: {products.length}
                </div>
                {hasWritePermission() && (
                  <button className="btn-add-product" onClick={() => { setEditingProduct(null); setShowForm(true); }}>
                    + Add Product
                  </button>
                )}
              </div>
            </div>
          </div>

          <ProductTable
            products={filteredProducts}
            onDelete={handleDelete}
            onEdit={handleEdit}
            canWrite={hasWritePermission()}
          />
        </>
      ) : (
        <>
          <div className="page-header">
            <div className="header-with-back">
              <button className="back-btn" onClick={cancelEdit}>← Back</button>
              <h2 className="adminproducts">
                {editingProduct ? "Update Product" : "Create New Product"}
              </h2>
            </div>
          </div>
          <div className="form-inline-container">
            <ProductForm
              product={editingProduct}
              onSuccess={() => {
                setEditingProduct(null);
                setShowForm(false);
                fetchProducts();
              }}
              onCancel={cancelEdit}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default ProductsPage;

